<template>
  <div class="tiers my-2 py-4 px-4">
    <v-btn class="remove-button" icon @click="$emit('remove', tier)">
      <v-icon>mdi-close</v-icon>
    </v-btn>
    <ValidationProvider v-slot="{ errors }" rules="required">
      <v-text-field
        :error-messages="getErrorMessages(errors)"
        label="Name"
        class="mt-2"
        v-model="tier.tier_name"
      />
    </ValidationProvider>
    <div class="d-flex align-center justify-end">
      <v-checkbox
        v-model="isAutoPublish"
        @change="handleAutoPublish"
        class="mt-3"
        label="Never Publish Automatically or"
      />
      <ValidationProvider v-slot="{ errors }" rules="minNumber:1">
        <v-text-field
          :error-messages="getErrorMessages(errors)"
          class="mx-1 my-1"
          prefix="Delayed by"
          suffix="hours"
          type="number"
          min="0"
          v-model="tier.publishing_delay_hours"
          :disabled="isAutoPublish"
        />
      </ValidationProvider>
    </div>
    <Select
      label="Select Channels"
      v-model="channelIds"
      item-text="channelName"
      item-value="id"
      :items="channels"
      :loading="isFetchingChannels"
      :value="tier.publishingChannels"
      @change="updateTierChannels"
      multiple
      autocomplete
      chips
    >
      <template v-slot:selection="{ data }">
        <v-chip>
          {{ data.item.channelName }}
        </v-chip>
      </template>
    </Select>
  </div>
</template>

<script>
import { ValidationProvider } from "vee-validate";
import Select from "@/components/common/Select";
import { FETCH_CHANNELS } from "@/store/modules/organisations/organisation-schedules/actions";
import { ORGANISATION_SCHEDULES_NAMESPACE } from "@/store/modules/organisations/organisation-schedules";
import { createNamespacedHelpers } from "vuex";
import { copyState } from "@/utils/helpers";
import { map } from "lodash";

const { mapActions, mapState } = createNamespacedHelpers(
  ORGANISATION_SCHEDULES_NAMESPACE
);

export default {
  components: {
    ValidationProvider,
    Select
  },
  props: {
    tier: Object,
    showValidationErrors: Boolean
  },
  created() {
    this.fetchChannels();
    this.setChannelIds();
    const hasDelayedHours = Boolean(this.tier.publishing_delay_hours);
    this.isAutoPublish = !hasDelayedHours;
  },
  data() {
    return {
      channelIds: [],
      isAutoPublish: false
    };
  },
  computed: {
    ...mapState(copyState(["channels", "isFetchingChannels"]))
  },
  methods: {
    ...mapActions({
      fetchChannels: FETCH_CHANNELS
    }),
    getErrorMessages(errors) {
      return this.showValidationErrors ? errors : "";
    },
    updateTierChannels() {
      this.tier.publishingChannels = map(this.channelIds, id => ({ id }));
    },
    setChannelIds() {
      this.channelIds = map(
        this.tier.publishingChannels,
        channel => channel.id
      );
    },
    handleAutoPublish(autoPublish) {
      const publishing_delay_hours = autoPublish ? null : 1;
      this.tier.publishing_delay_hours = publishing_delay_hours;
    }
  }
};
</script>

<style lang="scss">
.tiers {
  border: 1px solid rgb(63, 62, 62);
  border-radius: 5px;
  position: relative;
  .remove-button {
    position: absolute;
    top: 5px;
    right: 5px;
  }
}
</style>
